<script>
  import options from './FundraisingCard.options'
  export default options
</script>

<template>
  <a :href="result.url" class="kb-fundraising-card">
    <section class="kb-fundraising-card__image-container">
      <img :src="result.imgUrl" alt="">
    </section>

    <section class="kb-fundraising-card__content">
      <h3 class="kb-fundraising-card__content__title">{{ result.name }}</h3>

      <div class="kb-fundraising-card__content__fundraise-container">
        <p class="kb-fundraising-card__content__price">{{ current }}</p>

        <div v-if="!isMindegaveLayout" class="kb-fundraising-card__progress-bar">
          <div
            class="kb-fundraising-card__progress-bar__inner"
            :class="{ full: progress === 100 }"
            :style="'width: ' + progress + '%'"
          ></div>
        </div>

        <p v-if="!result.hideTarget" class="kb-fundraising-card__content__target">
          Indsamlingsmål: {{ target }}
        </p>
      </div>
    </section>
  </a>
</template>